import Vue from "vue";
import Toast from "vue-toastification";

Vue.use(Toast, {
  pauseOnHover: true,
  closeOnClick: true,
  timeout: 5000,
});

const Plugin = {};

Plugin.install = function (Vue) {
  Vue.prototype.$notification = {};

  Vue.prototype.$notification.info = (message, options) => {
    Vue.prototype.$toast.info(message, options);
  };

  Vue.prototype.$notification.warning = (message, options) => {
    Vue.prototype.$toast.warning(message, options);
  };

  Vue.prototype.$notification.error = (message, options) => {
    Vue.prototype.$toast.error(message, options);
  };
}

export default Plugin;
